import { APIService } from "services";

export const getDesignation = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllDesignation(pageNo,pageSize);
    }
    else{
        try {
            res = await searchDesignation(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addDesignation = (data) => {
return APIService.api().post(`/designation`,data)
}
export const updateDesignation = (designation_id,data) => {
return APIService.api().patch(`/designation/${designation_id}`,data)
}
export const getAllDesignation = (pageNo,pageSize) => {
return APIService.api().get(`/designation/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneDesignation = (designation_id) => {
return APIService.api().get(`/designation/${designation_id}`)
}
export const searchDesignation = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/designation/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteDesignation = (designation_id) => {
return APIService.api().delete(`/designation/${designation_id}`)
}
